const ledgerAccountOrderingTypes = {
  DEFAULT: 'DEFAULT',
  MONEY_IN_TRANSIT: 'MONEY_IN_TRANSIT',
};

export default ledgerAccountOrderingTypes;
